import RedButton from '@/components/atoms/RedButton';
import BancoDoAuto25BlackBG from '@/components/organisms/BancoDoAuto25BlackBG';
import BancoDoAuto25Stack from '@/components/organisms/BancoDoAuto25Stack';
import BancoDoAuto25Video from '@/components/organisms/BancoDoAuto25Video';
import Styles from './BancoDoAuto25.css';
import Head from 'next/head';
import React from 'react';
import BancoAutoCarro from '@/components/molecules/BancoAutoCarro';
import BancoAutoFinancieCarro from '@/components/molecules/BancoAutoFinancieCarro';
import BancoAutoCarroDesktop from '@/components/molecules/BancoAutoCarroDesktop';
import BancoDoAutoPerguntas from '@/components/organisms/BancoDoAutoPerguntas';
import BancoDoAuto25Blog from '@/components/organisms/BancoDoAuto25Blog';
import { isMobile } from '../../../utils/browser';

function BancoDoAuto25() {
  const faqTitle = 'Saiba mais sobre financiamento de veículos';
  const imgpng = 'assets/banco-do-auto25/img-perguntas-carro.png';
  const imgwebp = 'assets/banco-do-auto25/img-perguntas-carro.webp';
  const imgalt = 'Casal dentro de um carro financiado pelo Santander';
  const faqs = [
    {
      pergunta: 'Quem pode financiar um carro?',
      resposta:
        'Qualquer cliente que precise de um veículo, tanto para passeio, quanto para trabalho. Também oferecemos crédito para Pessoas com Deficiência (PCD) que desejam comprar um veículo adaptado às suas necessidades.',
    },
    {
      pergunta: 'Quais documentações necessárias para realizar um financiamento?',
      resposta: 'Precisamos de seus documentos de identificação: RG, CPF e CNH.',
    },
    {
      pergunta: 'É possível financiar 100% do valor de um veículo?',
      resposta:
        'Sim, em cada simulação é feita uma análise para definir as condições de financiamento liberadas para cada cliente.',
    },
    {
      pergunta:
        'Quais dados são necessários para realizar uma simulação em uma loja ou concessionária?',
      resposta:
        'Basta apenas o CPF/CNPJ do cliente para conseguir realizar uma simulação de financiamento.',
    },
    {
      pergunta: 'É necessário ser correntista Santander para realizar financiamento com o Banco?',
      resposta:
        'Não há necessidade do cliente já ser correntista Santander, porém ele tem a opção de se tornar correntista durante a jornada de financiamento e aproveitar diversos benefícios.',
    },
    {
      pergunta: 'Qual é a taxa de juros do financiamento?',
      resposta:
        'A taxa de juros vai depender de cliente para cliente. Isso porque é realizada uma análise de crédito no momento do financiamento.',
    },
  ];

  return (
    <>
      <Head>
        <title>Financiamento de Veículos | Move Brasil para Motoristas</title>
        <meta
          name="keywords"
          content="simular financiamento, Financiamento de veículos, financiamento Santander, Santander financiamentos, Santander Financiamento, transferir financiamento de veículo, comprar um carro novo, financiamento carro, meu financiamento santander"
        />
        <meta
          name="Description"
          content="Financie carro zero km de até R$ 150 mil pelo Programa Move Brasil para motoristas de aplicativo e taxistas na Santander Financiamentos. Simule!"
        />
        <meta name="robots" content="index,follow" />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/banco-do-auto.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta
          property="og:title"
          content="Financiamento de Veículos | Move Brasil para Motoristas"
        />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/banco-do-auto.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Financie carro zero km de até R$ 150 mil pelo Programa Move Brasil para motoristas de aplicativo e taxistas na Santander Financiamentos. Simule!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/banco-do-auto25/banners/bg-banner.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem branco de camisa xadrez vermelha comprando um veiculo e realizando um financiamento na Santander financiamento."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Financiamento de Veículos | Move Brasil para Motoristas"
        />
        <meta
          name="twitter:description"
          content="Financie carro zero km de até R$ 150 mil pelo Programa Move Brasil para motoristas de aplicativo e taxistas na Santander Financiamentos. Simule!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/banco-do-auto.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/banco-do-auto25/banners/bg-banner.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem branco de camisa xadrez vermelha comprando um veiculo e realizando um financiamento na Santander financiamento."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
        <script
          id="richsnippets-list"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context":"https://schema.org","@graph":[{"@type":"FAQPage","mainEntity":[{"@type":"Question","name":"O que é o Programa Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"O Move Brasil é uma linha de crédito de até R$ 30 bilhões do governo federal para financiamento de veículos zero quilômetro destinados a taxistas e motoristas de aplicativo, com condições e taxas de juros mais atrativas que as praticadas no mercado."}},{"@type":"Question","name":"Quem pode participar do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"Podem participar motoristas de aplicativo com cadastro ativo na mesma plataforma há pelo menos 12 meses e que tenham realizado ao menos 100 corridas nesse período, além de taxistas que atendam aos requisitos do programa."}},{"@type":"Question","name":"Até quando vai o programa Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"A vigência do programa pode variar conforme a modalidade. Consulte os canais oficiais para verificar os prazos atualizados de contratação."}},{"@type":"Question","name":"Quais carros podem ser financiados pelo Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"O programa contempla veículos zero quilômetro de até R$ 150 mil, incluindo modelos flex eficientes, híbridos flex, elétricos e movidos exclusivamente a etanol, desde que sejam produzidos por montadoras habilitadas no Programa Mover."}},{"@type":"Question","name":"Como saber se tenho direito ao subsídio Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"O interessado deve realizar o cadastro na plataforma oficial do programa utilizando sua conta gov.br. A análise de elegibilidade é realizada em até 5 dias úteis, com retorno enviado pela caixa postal do gov.br."}},{"@type":"Question","name":"Quais carros elétricos participam do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"Entre os modelos elegíveis estão BYD Atto 2 DM-i, BYD Dolphin, BYD Dolphin Mini, BYD King DM-i, GWM Ora 03, Chevrolet Spark EUV e Geely EX2. A lista de veículos pode ser atualizada periodicamente."}},{"@type":"Question","name":"Quais carros flex participam do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"Entre os modelos flex elegíveis estão Chevrolet Onix, Onix Plus e Tracker; Fiat Argo, Cronos, Pulse e Fastback; Volkswagen Polo e T-Cross; Renault Kardian; e Nissan Versa."}},{"@type":"Question","name":"Quais carros híbridos participam do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"O programa contempla modelos híbridos elegíveis que atendam aos critérios de eficiência energética e valor máximo definidos pelo governo federal. Consulte a lista atualizada de veículos participantes."}},{"@type":"Question","name":"A Santander Financiamentos participa do programa Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"Sim. A Santander Financiamentos oferece crédito para veículos elegíveis ao Move Brasil, sujeito à análise de crédito e às condições vigentes."}},{"@type":"Question","name":"Como financiar um carro elétrico pelo Move Brasil no Santander?","acceptedAnswer":{"@type":"Answer","text":"Escolha um veículo participante do programa, realize a simulação e opte pela Santander Financiamentos. Após o envio da documentação necessária, o pedido passará por análise para contratação."}},{"@type":"Question","name":"Quais veículos podem ser financiados pelo Santander dentro do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"Podem ser financiados veículos zero quilômetro elegíveis ao programa, incluindo modelos flex, híbridos e elétricos que atendam aos critérios estabelecidos pelo governo."}},{"@type":"Question","name":"Por que financiar com o Santander?","acceptedAnswer":{"@type":"Answer","text":"O Santander oferece parcelamento em até 60 meses, carência de até 6 meses para o pagamento da primeira parcela e taxas fixas a partir de 0,91% ao mês para mulheres e 0,99% ao mês para os demais perfis, além da segurança e solidez de uma das maiores instituições financeiras do país."}},{"@type":"Question","name":"Qual é o valor máximo de financiamento do Move Brasil?","acceptedAnswer":{"@type":"Answer","text":"O programa contempla veículos com valor de até R$ 150 mil para motoristas de aplicativo e taxistas elegíveis."}}]},{"@type":"FinancialProduct","name":"Financiamento de veículos","description":"Financiamento para compra de veículos novos e usados.","provider":{"@type":"Organization","name":"Santander Financiamentos"},"url":"https://www.santander.com.br/hotsite/santanderfinanciamentos/banco-do-auto.html"}]}`,
          }}
        />
      </Head>
      <BancoDoAuto25BlackBG id="financiamento-carro">
        <div className="container-imagem mobile">
          {/* <div className="linear-gradiente" /> */}
          <picture>
            <source type="image/webp" srcSet="assets/banco-do-auto25/financiamento-carro.webp" />
            <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-carro.png" />
            <img
              src="assets/banco-do-auto25/financiamento-carro.png"
              alt="Mulher branca de camisa vermelha dirigindo um carro financiado pelo Santander"
            />
          </picture>
        </div>
        <BancoDoAuto25Stack>
          <div className="container-imagem desktop">
            {/* <div className="linear-gradiente" /> */}
            <picture>
              <source type="image/webp" srcSet="assets/banco-do-auto25/financiamento-carro.webp" />
              <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-carro.png" />
              <img
                src="assets/banco-do-auto25/financiamento-carro.png"
                alt="Mulher branca de camisa vermelha dirigindo um carro financiado pelo Santander"
              />
            </picture>
          </div>
          <div className="c2c-stack-content-veiculo">
            <img src="assets/banco-do-auto25/ic_vehicle_car.svg" alt="veiculo" />
            <h1 className="c2c-stack-title">Financiamento de carro</h1>
            <p className="c2c-stack-subtitle">
              O financiamento de carro no Santander é o caminho para comprar um veículo de forma
              segura e confiável.
              <br />
              <br />
              Na Santander Financiamentos, você conta com toda a garantia que oferecemos aos nossos
              clientes, tanto nos financiamentos, como nos seguros.
            </p>
            <RedButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&amp;int_medium=banco-do-auto:2a-dobra&amp;int_campaign=simular"
              className="btn-simule"
              target="_blank"
            >
              Simular
            </RedButton>
          </div>
        </BancoDoAuto25Stack>
      </BancoDoAuto25BlackBG>
      {isMobile() && <BancoAutoCarro />}
      <BancoAutoFinancieCarro />
      {!isMobile() && <BancoAutoCarroDesktop />}
      <BancoDoAutoPerguntas
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
      />
      <BancoDoAuto25Blog />
      <style jsx>{Styles}</style>
    </>
  );
}

export default BancoDoAuto25;
